import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';



function UploadExcel({ setExcelData }) {
  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      const filteredData = jsonData.map((row) => ({
        ANR: row[0],
        Artikelnummer: row[4],
        Menge: row[5],
        Auftragsbezeichnung: row.slice(6, 10).join(''), // Concatenate from column 7 to 10
      }));

      setExcelData(filteredData);
    };
    reader.readAsArrayBuffer(file);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()} style={dropzoneStyle}>
      <input {...getInputProps()} accept=".xlsx" />
      {isDragActive ? (
        <p>Drop the Excel file here...</p>
      ) : (
        <p>Drag &apos;n&apos; drop an Excel file here, or click to select one</p>
      )}
    </div>
  );
}

const dropzoneStyle = {
  border: '2px dashed #cccccc',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
};

UploadExcel.propTypes = {
  setExcelData: PropTypes.func.isRequired,
};

export default UploadExcel;